import React from 'react';
import { Spin, Button, message } from "antd";
import ReactDOM from 'react-dom';
import DataService from '../../lib/DataService';
import AjaxBase from '../../../../lib/AjaxBase';

export default class ImportAllTeachersPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired, // this is passed from the Rails view
  };

  /**
   * @param props - Comes from your rails view.
   */
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      newValue: '',
      schoolId: props.params.schoolId,
      file: null,
      results: {
        dismiss_list: [],
        fail_list: [],
        success_list: []
      },
      uploading: false,
    }
  }

  onDownloadQuestionnaireTempalte(e) {
    e.stopPropagation();
    let downloadWindown = window.open(AjaxBase.URL_PREFIX + `schools/export_teachers_template`);
  }

  getValue(e) {
    let file = ReactDOM.findDOMNode(this.refs.fileDom).files[0];
    this.setState({
      value: e.target.value,
      file: file
    }, () => {
      var arr = this.state.value.split('\\');
      this.setState({
        newValue: arr[arr.length - 1],
      })
    })
  }

  uploadFile() {
    if (!this.state.file) {
      return;
    }
    this.setState({
      uploading: true,
      results: {
        dismiss_list: [],
        fail_list: [],
        success_list: []
      },
    });
    DataService.importAllTeachers(this.state.schoolId, this.state.file).then((response) => {
      this.setState({
        results: response,
        uploading: false,
      });
      message.success("上传成功");
    }, (error) => {
      this.setState({
        uploading: false,
      });
      switch (error.errorMessage.errors[0].code) {
        case 51:
          message.error("无法打开文件，请确认格式后重新上传");
          break;
        default:
          message.error("上传失败");
      }
    }).catch((error) => {
      console.log(error);
      message.error("上传失败");
      this.setState({
        uploading: false,
      });
    })
  }

  _dismissList() {
    if (this.state.results.dismiss_list.length > 0) {
      return (
        <div>
          <div>冲突：</div>
          {this.state.results.dismiss_list.map((resultLine, index) => {
            return (<ImportQuestionnaireRow key={index} resultLine={resultLine} type={"dismiss"} />)
          })}
        </div>
      );
    }
  }

  _failList() {
    if (this.state.results.fail_list.length > 0) {
      return (
        <div>
          <div>校验错误：</div>
          {this.state.results.fail_list.map((resultLine, index) => {
            return (<ImportQuestionnaireRow key={index} resultLine={resultLine} type={"fail"} />)
          })}
        </div>
      );
    }
  }

  _successList() {
    if (this.state.results.success_list.length > 0) {
      return (
        <div>
          <div>导入成功：</div>
          {this.state.results.success_list.map((resultLine, index) => {
            return (<ImportQuestionnaireRow key={index} resultLine={resultLine} type={"success"} />)
          })}
        </div>
      );
    }
  }

  _mainNavView() {
    return (
      <div>
        <Spin spinning={this.state.uploading} size={"large"} tip={"正在上传"} delay={500}>
          <div className="main-nav">
            导入老师名单
          </div>
          <div className="rule-declaration">
            <p>规则说明</p>
            <p className="text-tab">1.请先<span className="underline" onClick={this.onDownloadQuestionnaireTempalte.bind(this)}>下载批量导入模版</span></p>
            <p className="text-tab">2.按照模版中的例子，把老师信息填入excel表格</p>
            <p className="text-tab">3.上传excel文件，文件会进行校验，校验有误的老师将不会导入</p>
          </div>
          <div className="import-container">
            <span>请选择要导入的文件</span>
            <div className="import-box">
              <input className="import-btn" value="选择文件" type="button" />
              <input type="file" ref="fileDom" className="import-file" onChange={this.getValue.bind(this)} />
            </div>
            <input value={this.state.newValue} />
            <Button type="primary" className="info-submit" onClick={this.uploadFile.bind(this)}>上传数据</Button>
          </div>
          <div className="results">
            {this._dismissList()}
            {this._failList()}
            {this._successList()}
          </div>
        </Spin>
      </div>
    )
  }

  render() {
    return (
      <div className="import-info-page">
        {this._mainNavView()}
      </div>
    );
  }
}

class ImportQuestionnaireRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultLine: this.props.resultLine,
      type: this.props.type,
    };
  }

  render() {
    const errorMessage = {
      11: '数据有误或缺失',
      12: '手机号位数错误',
      13: '班级名称错误',
      14: '该手机号已存在，老师姓名不一致',
    }; // from app/api/v1/answer_sheets_controller.rb #batch_upload_answer_sheet
    const typeMessage = {
      "success": "导入成功",
      "dismiss": "冲突",
      "fail": "导入失败",
      "undefined": ""
    }

    let message = '';
    // if (this.state.resultLine.code == 13) {
    //   message = '，卡号重复：' + this.state.resultLine.c_ids.join(',');
    // }

    return (
      <div className={this.props.type == 'fail' || this.props.type == 'dismiss' ? 'fail-text' : ''}>{`第${this.state.resultLine.line}行，` + (this.state.resultLine.code ? `${errorMessage[this.state.resultLine.code] + message}` : `${this.state.resultLine.name}，${this.state.resultLine.class}，${typeMessage[this.state.type]}`)}</div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/ImportAllTeachersPage.jsx